module.exports = __webpack_public_path__ + "static/2-2cc2e2951874ff3a2cb5faed5f182b3d.jpg";